import { Component } from 'react';
import { withRouter } from 'react-router';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import PropTypes from 'prop-types';
import TransferenceMassiveSignForm from '../../components/transference-massive-sign-form/TransferenceMassiveSignForm';

class TransferenceMassiveSign extends Component {
  render() {
    return (
      <div>
        <div className="page-title">
          <FontAwesomeIcon icon="list-alt" alt="Icon" className="icon-title" />
          <h2 className="text-title">Firma masiva de contratos</h2>
        </div>
        <div className="main-wrapper-page">
          <TransferenceMassiveSignForm operationId={this.props.match.params.operationId} />
        </div>
      </div>
    );
  }
}

TransferenceMassiveSign.propTypes = {
  match: PropTypes.object,
};

export default withRouter(TransferenceMassiveSign);
